import { css } from '@emotion/react'
import { FC, useMemo } from 'react'
import { useField } from 'react-final-form'
import isURL from 'validator/lib/isURL'

import FieldError from '~/form/components/atoms/FieldError'
import FieldLabel from '~/form/components/atoms/FieldLabel'
import HelperText from '~/form/components/atoms/HelperText'
import InputFile from '~/form/components/molecules/InputFile'

import TextField from './TextField'

export type Props = {
  namePrefix: string
  label: string
  isConfirm: boolean
  helperText?: string
  fileAccept?: string
  required?: boolean
  urlPlaceholder?: string
}

const UrlFileFiled: FC<Props> = ({
  namePrefix,
  label,
  isConfirm,
  helperText,
  fileAccept,
  required = false,
  urlPlaceholder,
}) => {
  const urlName = `${namePrefix}Url`
  const dataName = `${namePrefix}File`

  const { meta: metaUrl } = useField(urlName)
  const { meta: metaData } = useField(`${dataName}.data`)
  const { meta: metaFile } = useField(`${dataName}.file`)

  const isUrlShowError = useMemo(
    () => metaUrl.error && metaUrl.touched,
    [metaUrl.error, metaUrl.touched]
  )

  const isDataShowError = useMemo(
    () => metaData.error && metaData.touched,
    [metaData.error, metaData.touched]
  )

  const isFileShowError = useMemo(
    () => metaFile.error && metaFile.touched,
    [metaFile.error, metaFile.touched]
  )

  return (
    <div>
      <FieldLabel
        label={label}
        required={required}
        isShowError={isUrlShowError || isDataShowError}
      />
      <div css={fileFieldBodyStyle}>
        <HelperText text={helperText} />
        {/* URL入力 */}
        <TextField
          name={urlName}
          type='url'
          placeholder={urlPlaceholder}
          isConfirm={isConfirm}
          validate={(value) => {
            if (!value) return
            if (!isURL(value)) {
              return `URLの形式に誤りがあります`
            }
          }}
        />
        {/* ファイル選択 */}
        <InputFile
          dataName={dataName}
          isConfirm={isConfirm}
          fileAccept={fileAccept}
        />
        <FieldError isShowError={isDataShowError} error={metaData.error} />
        <FieldError isShowError={isFileShowError} error={metaFile.error} />
      </div>
    </div>
  )
}

export default UrlFileFiled

const fileFieldBodyStyle = css`
  display: grid;
  row-gap: 10px;
`
